import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { LoomPluginAction, loomPluginKey } from './pm-plugin';
export var enableLoom = function enableLoom(_ref) {
  var loomButton = _ref.loomButton;
  return function (_ref2) {
    var tr = _ref2.tr;
    tr.setMeta(loomPluginKey, {
      type: LoomPluginAction.ENABLE,
      loomButton: loomButton
    });
    return tr;
  };
};
export var disableLoom = function disableLoom(_ref3) {
  var error = _ref3.error;
  return function (_ref4) {
    var tr = _ref4.tr;
    tr.setMeta(loomPluginKey, {
      type: LoomPluginAction.DISABLE,
      error: error
    });
    return tr;
  };
};
export var recordVideo = function recordVideo(_ref5) {
  var inputMethod = _ref5.inputMethod,
    editorAnalyticsAPI = _ref5.editorAnalyticsAPI;
  return function (_ref6) {
    var tr = _ref6.tr;
    tr.setMeta(loomPluginKey, {
      type: LoomPluginAction.RECORD_VIDEO
    });
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
      action: ACTION.RECORD_VIDEO,
      actionSubject: ACTION_SUBJECT.LOOM,
      attributes: {
        inputMethod: inputMethod
      },
      eventType: EVENT_TYPE.TRACK
    })(tr);
    return tr;
  };
};
export var recordVideoFailed = function recordVideoFailed(_ref7) {
  var inputMethod = _ref7.inputMethod,
    error = _ref7.error,
    editorAnalyticsAPI = _ref7.editorAnalyticsAPI;
  return function (_ref8) {
    var tr = _ref8.tr;
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
      action: ACTION.RECORD_VIDEO_FAILED,
      actionSubject: ACTION_SUBJECT.LOOM,
      attributes: {
        inputMethod: inputMethod,
        error: error
      },
      eventType: EVENT_TYPE.TRACK
    })(tr);
    return tr;
  };
};
export var insertVideo = function insertVideo(_ref9) {
  var editorAnalyticsAPI = _ref9.editorAnalyticsAPI,
    video = _ref9.video;
  return function (_ref10) {
    var tr = _ref10.tr;
    tr.setMeta(loomPluginKey, {
      type: LoomPluginAction.INSERT_VIDEO
    });
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
      action: ACTION.INSERT_VIDEO,
      actionSubject: ACTION_SUBJECT.LOOM,
      eventType: EVENT_TYPE.TRACK,
      attributes: {
        duration: video.duration
      }
    })(tr);
    return tr;
  };
};